// The stand-in images the Explore surfaces fall back to. Both live in `public/images/`, so they
// are plain absolute paths rather than imported modules — no bundler involvement, and they stay
// cacheable by the browser like any other static asset.
export const CourseImageConstants = {
  // Shown on any course that has no logo of its own, which is nearly all of them: the logo
  // backfill has reached 1 of 41,119 courses so far. It is the GolfPlayed mark on a black rounded
  // tile — dark artwork, so unlike a real club logo it must NOT sit on the white plate the real
  // ones need, or the tile floats in a white box.
  DEFAULT_LOGO: '/images/default-course-logo.png',

  // Shown in place of the logo on every course marked Closed (Course.Closed), whether or not it has
  // a logo of its own: "Closed" in white script on black. Dark artwork like DEFAULT_LOGO, so it is
  // treated the same way (no white plate where a surface tells the two apart). The course's own
  // logo is kept and only the admin edit page shows it; see utils/courseClosure.ts.
  CLOSED_LOGO: '/images/course-closed-logo.png',

  // The map marker for a single (unclustered) course. Loaded into the Mapbox style as an image
  // and drawn by the `unclustered-point` symbol layer — see exploreMapLayers.ts.
  // The `%20` is not optional: the folder name really does contain a space, and Mapbox's image
  // loader passes this straight to an XHR without encoding it.
  COURSE_PIN: '/images/Map%20pins/GP_Course.png',

  // The shared header photo for any course without its own (HeaderImageUrl), which is nearly all
  // of them. See "Known issues and backlog" in docs/EXPLORE.md.
  DEFAULT_HEADER: '/images/default-course-header.jpg',
} as const;

export default CourseImageConstants;
